// status-circle.type.ts
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-status-circle',
    imports: [CommonModule, MatIconModule],
    template: `
        <div
            *ngIf="!to.hidden"
            class="my-2 flex items-center gap-2 cursor-pointer select-none"
            (click)="toggle()"
            [attr.aria-checked]="formControl.value"
            role="checkbox">
            <div
                class="relative hover:cursor-pointer w-6 h-6 rounded-full border-2 transition-all duration-200 flex items-center justify-center"
                [ngClass]="getClasses()">
                <div
                    class="w-3 h-3 rounded-full transition-all duration-200"
                    [ngClass]="getCheckedClasses()">
                </div>
            </div>

            <label *ngIf="to.label">{{ to.label }}</label>
        </div>
    `,
    standalone: true,
})
export class FormlyStatusCircleComponent extends FieldType {
    getClasses() {
        const status = this.to?.status || 'INACTIVE';
        const checked = this.formControl.value;

        const base = {
            DEVELOPMENT: 'border-blue-500',
            IMPLEMENTATION: 'border-amber-500',
            ACTIVE: 'border-green-500',
            INACTIVE: 'border-gray-500',
        };

        const fill = {
            DEVELOPMENT: 'bg-blue-200',
            IMPLEMENTATION: 'bg-amber-200',
            ACTIVE: 'bg-green-200',
            INACTIVE: 'bg-gray-200',
        };

        return `${base[status]} ${checked ? fill[status] : 'bg-transparent'}`;
    }

    getCheckedClasses() {
        const status = this.to?.status || 'INACTIVE';
        const checked = this.formControl.value;

        const base = {
            DEVELOPMENT: 'bg-blue-500',
            IMPLEMENTATION: 'bg-amber-500',
            ACTIVE: 'bg-green-500',
            INACTIVE: 'bg-gray-500',
        };

        return `${checked ? base[status] : 'bg-transparent'}`;
    }

    toggle() {
        this.formControl.setValue(!this.formControl.value);
    }
}
